// extracted by mini-css-extract-plugin
export default {"backInfoImage":"style_backInfoImage__f2Akt","infoImageContent":"style_infoImageContent__BKfED"};